import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ReferenceLine,
  Tooltip,
  XAxis,
  YAxis,
  ResponsiveContainer,
} from "recharts";

// #region Sample data
const data = [
  {
    name: "03.10.2025",
    жиры: 4000,
    углеводы: 2400,
    белки: 2400,
  },
  {
    name: "04.10.2025",
    жиры: 3000,
    углеводы: 1398,
    белки: 2210,
  },
  {
    name: "05.10.2025",
    жиры: 2000,
    углеводы: 9800,
    белки: 2290,
  },
  {
    name: "06.10.2025",
    жиры: 2780,
    углеводы: 3908,
    белки: 2000,
  },
  {
    name: "07.10.2025",
    жиры: 1890,
    углеводы: 4800,
    белки: 2181,
  },
  {
    name: "08.10.2025",
    жиры: 2390,
    углеводы: 3800,
    белки: 2500,
  },
  {
    name: "09.10.2025",
    жиры: 3490,
    углеводы: 4300,
    белки: 2100,
  },
];

// #endregion
const LineChartGraphic = () => {
  return (
    <div
      style={{
        width: "90%",
        height: "50vh",
        minHeight: "300px",
        maxHeight: "400px",
        backgroundColor: "var(--bcg)",
        marginLeft: "10px",
        marginTop: "10px",
      }}
      // style={{ marginLeft: "-30px", marginRight: "30px" }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          style={{
            width: "100%",
            maxWidth: "500px",
            height: "50vh",
            minHeight: "300px",
            maxHeight: "420px",
            // aspectRatio: 1.618,
          }}
          //   responsive
          data={data}
          margin={{
            top: 20,
            right: 0,
            left: 0,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          {/* <YAxis width="auto" /> */}
          <YAxis width={100} />
          <Tooltip />
          <Legend
            verticalAlign="top"
            align="center"
            layout="horizontal"
            wrapperStyle={{
              top: 0,
              left: 0,
              right: 0,
              paddingBottom: 0,
            }}
          />
          {/* <ReferenceLine x="Page C" stroke="red" label="Max PV PAGE" /> */}
          <ReferenceLine y={4000} label="Углеводы" stroke="red" />
          <ReferenceLine y={2500} label="Белки и жиры" stroke="red" />

          <Line type="monotone" dataKey="углеводы" stroke="#8884d8" />
          <Line type="monotone" dataKey="жиры" stroke="#82ca9d" />
          <Line type="monotone" dataKey="белки" stroke="#302f18ff" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
export default LineChartGraphic;
